export default function WelcomeSplash() {
  return (
    <div className="lg:flex h-full flex-col justify-between bg-accent-gradient hidden">
      <div className="space-y-8 pb-24">
        <div>
          <h1 className="text-3xl font-normal text-primary-dark">
            Welcome to Dsquares!
          </h1>
          <h2 className="max-w-[38rem] text-5xl font-medium text-primary-dark">
            Keeping your customers loyal.
          </h2>
        </div>
        <p className="max-w-[34rem] text-xl font-thin text-primary-dark">
          Join our worldwide network of merchant and unlock endless business
          opportunities and unparalleled growth potential.
        </p>
      </div>
    </div>
  );
}
